<div class="organization-plan-info-card">
  <div class="organization-plan-info-card__left">
    <p class="organization-plan-info-card__type">{{ planTypeName | translate }}</p>
    <div
      class="organization-plan-info-card__price-container"
      *ngIf="subscription.type === enumSubscriptionType.BASIC; else paidSubscriptionCost"
    >
      <p class="organization-plan-info-card__price">{{ "LABELS.ORGANIZATION_PLAN_FREE" | translate }}</p>
    </div>
    <ng-template #paidSubscriptionCost>
      <div class="organization-plan-info-card__price-container">
        <p class="organization-plan-info-card__price">${{ subscription.price }}</p>
        /
        <span>{{ "BUTTON.MONTH" | translate }}</span>
      </div>
    </ng-template>
    <p class="organization-plan-info-card__service-rates">+ {{ "LABELS.ORGANIZATION_PLAN_SERVICE_RATES" | translate }}</p>
  </div>
  <div class="organization-plan-info-card__right">
    <div class="organization-plan-info-card__benefit-item" *ngFor="let benefit of subscriptionBenefits">
      <i class="fa fa-check organization-plan-info-card__benefit-item__icon" aria-hidden="true"></i>
      <p class="organization-plan-info-card__benefit-item__text" [innerHTML]="getPriceConvertedBenefitText(benefit, subscription)"></p>
    </div>
    <div class="organization-plan-info-card__benefit-item">
      <i class="fa fa-check organization-plan-info-card__benefit-item__icon-blank" aria-hidden="true"></i>
      <p class="organization-plan-info-card__benefit-disclaimer">{{ planTypeDisclaimer | translate }}</p>
    </div>
  </div>
</div>
